<script setup lang="ts">
import { Icon } from '@iconify/vue';
import AppsLink from './AppsLink.vue';
</script>

<template>
  <v-menu
    open-on-hover
    open-on-click
  >
    <template #activator="{ props }">
      <v-btn
        class="hidden-sm-and-down custom-hover-primary"
        size="small"
        variant="text"
        icon
        color="primary"
        v-bind="props"
      >
        <Icon
          icon="solar:widget-3-line-duotone"
          height="20"
        />
      </v-btn>
    </template>

    <v-sheet
      width="900"
      height="300"
      elevation="10"
      rounded="md"
      class="pa-0 overflow-hidden"
    >
      <div>
        <v-row class="ma-0">
          <v-col
            cols="12"
            md="8"
            class="d-flex"
          >
            <div class="pa-6 w-100">
              <AppsLink />
            </div>
          </v-col>
          <v-col
            cols="12"
            md="4"
            class="pa-0"
          >
            <img
              src="@/assets/images/backgrounds/mega-dd-bg.jpg"
              alt="Mega menu background"
              height="300"
              class="w-100 object-fit-cover"
            >
          </v-col>
        </v-row>
      </div>
    </v-sheet>
  </v-menu>
</template>

<style scoped lang="scss">
.object-fit-cover {
  object-fit: cover;
}
</style>
